var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19.5,
    viewBox: "0 0 18 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106342",
    "data-name": "Path 106342",
    d: "M52.25,764.5H48.5v-.75a2.25,2.25,0,0,0-2.25-2.25h-4.5a2.25,2.25,0,0,0-2.25,2.25v.75H35.75a.75.75,0,0,0,0,1.5h.75v13.5A1.5,1.5,0,0,0,38,781H50a1.5,1.5,0,0,0,1.5-1.5V766h.75a.75.75,0,0,0,0-1.5ZM41,763.75a.751.751,0,0,1,.75-.75h4.5a.751.751,0,0,1,.75.75v.75H41Zm9,15.75H38V766H50Zm-7.5-9.75v6a.75.75,0,0,1-1.5,0v-6a.75.75,0,0,1,1.5,0Zm4.5,0v6a.75.75,0,0,1-1.5,0v-6a.75.75,0,0,1,1.5,0Z",
    transform: "translate(-35 -761.5)",
    fill: "#1c1c1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiBin);
export default __webpack_public_path__ + "static/media/visionai_bin.3e07d7b244306b80151b991ab13a5e3d.svg";
export { ForwardRef as ReactComponent };